import { css } from 'src/styles/theme';
import { rem } from 'polished';

export const selectButton = css`
    background: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
    font-size: ${({ theme }) => theme.fontSizes.h5};
    padding: ${rem(10)} ${rem(15)};
    font-weight: ${({ theme }) => theme.fontWeights.textRegular};
    border: ${rem('1px')} solid ${({ theme }) => theme.colors.primary};

    &:hover,
    &:focus-visible {
        border-color: ${({ theme }) => theme.colors.primary};
        background: ${({ theme }) => theme.colors.secondary};
        color: ${({ theme }) => theme.colors.white};
    }
`;
